async function mapAsync(array, fn, include = () => true) {
    return (await Promise.all(array.map(async (...params) => await fn(...params)))).filter(include)
}

async function filterAsync(array, fn) {
    return (
        await Promise.all(
            array.map(async (...params) => {
                const result = await fn(...params)
                if (result) {
                    return params[0]
                } else {
                    return null
                }
            })
        )
    ).filter(Boolean)
}

export { mapAsync }
export { filterAsync }
